<template>
  <div>
    <div id="myDiv" />
  </div>
</template>

<script>
export default {
  mounted () {
    const a = [
      { originPlace: 'Republica Dominicana', group: 'A', value: 50, color: '#ffd966', text: '50' },
      { originPlace: 'Republica Dominicana', group: 'B', value: 430, color: '#ffc166', text: '430' },
      { originPlace: 'Repubilica de Haiti', group: 'C', value: 93, color: '#66c1c1', text: '93' },
      { originPlace: 'Repubilica de Haiti', group: 'C', value: 1800, color: '#c9c9c9', text: '1.800' },
      { originPlace: 'Repubilica de Haiti', group: 'C', value: 180, color: '#66cff6', text: '180 THC' },
      { originPlace: 'Italia', group: 'D', value: 2690, color: '#8299c0', text: '2.690 Flete' }
    ]
    const parserItems = this.$helperPlugin.parserGroupsInValidChartItems(a)

    const trace1 = {
      x: parserItems.x,
      y: parserItems.y,
      name: 'Flete',
      type: 'bar',
      textposition: 'inside',
      text: parserItems.texts,
      hoverinfo: 'bottom',
      orientation: 'v',
      measure: ['relative', 'relative', 'relative'],
      connector: { visible: false },
      marker: {
        color: parserItems.colors
      }
    }

    const data = [
      trace1,
      ...parserItems.lines
    ]

    const layout = {
      xaxis: {
        type: 'category',
        visible: false,
        showticklabels: false
      },
      yaxis: {
        type: 'linear',
        visible: false,
        showticklabels: false
      },
      autosize: true,
      annotations: parserItems.annotations,
      showlegend: true,
      barmode: 'stack'
    }
    Plotly.newPlot('myDiv', data, layout) // eslint-disable-line
  }
}
</script>

<style scoped>

</style>
